
import * as OM from "@/Model";
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Options({})
export default class StripeSavedCards extends Vue {

    @Prop({
        default: () => []
    }) cards: OM.StripeCardDetailBM[];

    @Prop() value: string;

	selectedCard: OM.StripeCardDetailBM = new OM.StripeCardDetailBM();
	loaded = false;

	created() {
        this.$nextTick( () => {
            this.loaded = true;
        })
	}

	selectCard(card: OM.StripeCardDetailBM) {
		this.$emit('input', card.cardId);
    }
    
}
